import axios from "axios";
import moment from "moment";

const state = {
  baseUrl: process.env.NODE_ENV === 'production' ? 'https://bodyfittraining.com/' : 'https://www.benplain.com.au/bft/',
  posts: [],
  post: null
}
const mutations = {
    SET_ARTICLES(state, data) {
        state.posts = data
    },
    SET_ARTICLE(state, data) {
        state.post = data
    }
}
const actions = {
    loadArticles({commit, state, rootState}, featured) {

        if(rootState.global.offline) return

        commit('global/SET_SYNCING', 'Loading Articles', {root: true})

        //console.log(moment(rootState.challenge.challenge.start_date, 'DD/MM/YYYY'))

        var start = moment(rootState.challenge.challenge.preview_date, 'DD/MM/YYYY').format('YYYY-MM-DD')
        var end = moment(rootState.challenge.challenge.end_date, 'DD/MM/YYYY').format('YYYY-MM-DD')

        axios.get(state.baseUrl + 'challenge-articles/'
            + start + '_'
            + end + (featured ? '/featured' : ''))
            .then(async function (response) {
                //console.log('articles', response.data)
                //storage.set('posts', response.data.data)
                commit('SET_ARTICLES', response.data)
                commit('global/SET_SYNCING', null, {root: true})
            })
            .catch(function (error) {
                commit('global/SET_SYNCING', null, {root: true})
                //dispatch('setToken', null)
                //router.push('login')
                throw error.response
            })

    },
    loadArticle({commit, state, rootState}, value) {

        if(rootState.global.offline) {
            commit('SET_ARTICLE', 'not found')
            return
        }

        commit('SET_ARTICLE', null)

        commit('global/SET_SYNCING', 'Loading Article', {root: true})

        axios.get(state.baseUrl + 'challenge-article/' + value)
            .then(async function (response) {
                //console.log('article', response)
                //storage.set('posts', response.data.data)
                commit('SET_ARTICLE', response.data)
                commit('global/SET_SYNCING', null, {root: true})
            })
            .catch(function (error) {
                commit('global/SET_SYNCING', null, {root: true})
                //dispatch('setToken', null)
                //router.push('login')
                commit('SET_ARTICLE', 'not found')
                throw error.response
            })

    }
}
export default { 
  namespaced: true, state, mutations, actions
}
